import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/auth/helpers/app-config';
import { TopUps } from '../models/topup';
import { ListDataService } from './list-data.service';

@Injectable({
  providedIn: 'root'
})
export class TopupsService extends ListDataService<TopUps> {

  constructor(public http:HttpClient,public config:AppConfig ) {
    super(http,config,'/client/topups','/client/topup');
   }
}

